var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-15"},[_c('v-app-bar',{attrs:{"color":"#333333","fixed":"","dark":"","app":""}},[_c('v-toolbar-title',{staticClass:"ml-0 pl-3"},[_c('a',{attrs:{"href":'/'}},[_c('img',{staticClass:"logo-new",attrs:{"src":require("./../assets/images/new-logo.png")}})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }